import React from 'react';
import PropTypes from 'prop-types';

import { pathOr } from '@xingternal/malt-util/objects';
import { ProfileImage } from '@xingternal/profile-image';

import styles from './SubHeader.css';

const SubHeader = ({ user }) => {
  const { profileImage, displayName, firstName } = user;
  const image = pathOr(null, [0, 'url'], profileImage);

  const profileImageProps = {
    profileName: displayName,
    userName: firstName,
    showCaption: false,
    src: image,
    size: '32',
    width: '32',
    height: '32',
    'data-qa': 'checkout-header-image',
    styles,
  };

  return (
    <div className={styles.personalBarWrapper}>
      <ProfileImage {...profileImageProps} />
    </div>
  );
};

SubHeader.propTypes = {
  // xingConnect
  user: PropTypes.object.isRequired,
  // Props
  helpLink: PropTypes.string,
};

export { SubHeader };
